import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ListItem.scss';

export default class ListItem extends Component {
    static propTypes = {
        item: PropTypes.any.isRequired,
        onGoToItem: PropTypes.func
    };

    static defaultProps = {
        item: {}
    };

    render() {
        return (<div className="rules-list-item" key={this.props.item.key} onClick={this.props.onGoToItem}>
            <div className="rule-name">{this.props.item.ruleName}</div>
            <div className="merchant-info">{this.props.item.merchant} {this.props.item.merchantId}</div>
            <div className="rule-type">{this.props.item.ruleType}</div>
        </div>);
    }
}
